<template>
  <div
    class="rounded-pill py-2 pl-2 pr-3 text-nowrap"
    :class="[value ? 'has' : 'no-has']"
  >
    <span class="fa-stack">
      <i class="fas fa-circle fa-stack-2x" />
      <i
        class="fas fa-stack-1x"
        :class="{
          'fa-check': value,
          'fa-times': !value,
        }"
      />
    </span>
    {{ value ? trueText ?? text : falseText ?? ` No ${text}` }}
  </div>
</template>

<script>
export default {
  name: 'Badge',
  props: {
    value: {
      type: Boolean,
      default: () => false,
    },
    text: {
      type: String,
      default: () => '',
    },
    trueText: {
      type: String,
      default: () => null,
    },
    falseText: {
      type: String,
      default: () => null,
    },
  },
};
</script>

<style scoped>
.has > span,
.no-has > span {
  font-size: 10px;
  margin-bottom: 2px;
}

.has > span > i:last-child,
.no-has > span > i:last-child {
  color: white;
}

.has {
  background-color: #19bbef;
  color: white;
}
.has > span > i:first-child {
  color: #1277b9;
}
.no-has {
  background-color: #c9545e;
  color: white;
}
.no-has > span > i:first-child {
  color: #d4888c;
}
</style>
